/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon } from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import { Scrollbars } from 'react-custom-scrollbars';
import IconWithLabel from '../IconWithLabel/IconWithLabel';
import { PERMISSIONS } from "../../../constants/APP_CONSTANTS";

export default class SideNavBar extends React.Component {
    static propTypes = {
        isExpanded: PropTypes.bool,
        toggleExpanded: PropTypes.func,
        permissions:PropTypes.func.isRequired,
    }

    state = {
        activeItems: [],
        menuItems: [
            {
                "name": "Image Ingestion",
                "icon": "image-24",
                "items": [
                    {
                        "name": "Upload Cover Image",
                        "link": "/cover-image-upload"
                    },
                    {
                        "name": "Upload Cover Image Status",
                        "link": "/cover-status"
                    },
                    {
                        "name": "Upload Cover Image Metadata",
                        "link": "/cover-image-metadata-upload"
                    },
                    {
                        "name": "Upload Cover Image Metadata Status",
                        "link": "/cover-metadata-status"
                    },
                    {
                        "name": "Upload Cover Image Template Details",
                        "link": "/cover-image-template-detail-upload"
                    },
                    {
                        "name": "Upload Cover Image Template Status",
                        "link": "/cover-template-status"
                    }
                ]
            },
            {
                "name": "Accounts",
                "icon": "group-24",
                "items": [
                    {
                        "name": "Assign Roles",
                        "link": "/assign-roles"
                    }
                ]
            },
            
        ],
        saleRepMenuItems:[
            {
                "name": "Sales Rep Capabilities",
                "icon": "tip-24",
                "items": [
                    {
                        "name": "Sales Rep Search Link",
                        "link": "/salesrep-search"
                    },
                    {
                        "name": "Your Collections List",
                        "link": "/collection-list"
                    },
                ]
            }
        ]
    }

    toggleHeader = (name) => {
        if (!this.props.isExpanded) {
            this.toggleSidebar();

            this.setState({
                activeItems: [name]
            });
        } else {
            this.setState(prevState => ({
                activeItems: (prevState.activeItems.includes(name)
                    ? prevState.activeItems.filter((i) => i !== name)
                    : [...prevState.activeItems, name])
            }));
        }
    }

    toggleSidebar = () => {
        this.setState({
            activeItems: (this.props.isExpanded) ? [] : this.state.menuItems.map((_, i) => i)
        });

        this.props.toggleExpanded();
    }

    toggleSaleRepSidebar = () => {
        this.setState({
            activeItems: (this.props.isExpanded) ? [] : this.state.saleRepMenuItems.map((_, i) => i)
        });

        this.props.toggleExpanded();
    }

    render () {
        const userRolePermissions = this.props.permissions;
        const { isExpanded } = this.props;
        return (
            <div className="sidebar">
                <Scrollbars autoHide autoHeight autoHeightMin={0} autoHeightMax={"100%"}>
                    {!userRolePermissions.includes(PERMISSIONS.hide_only_sidebar_menuItems) ? <div className="menu">
                        {
                            this.state.menuItems.map((section, key) => (
                                <React.Fragment>
                                    <div className="menu-header" onClick={() => this.toggleHeader(key)}><IconWithLabel icon={section.icon} label={section.name} /></div>
                                    <ul className={(this.state.activeItems.includes(key) ? "" : "hidden")}>
                                        {
                                            section.items.map((name, key) => <li key={key}><Link to={name.link}>{name.name}</Link></li>)
                                        }
                                    </ul>
                                </React.Fragment>
                            ))
                        }
                    </div>: <div className="menu">
                        {
                            this.state.saleRepMenuItems.map((section, key) => (
                                <React.Fragment>
                                    <div className="menu-header" onClick={() => this.toggleSaleRepSidebar(key)}><IconWithLabel icon={section.icon} label={section.name} /></div>
                                    <ul className={(this.state.activeItems.includes(key) ? "hidden" : "")}>
                                        {
                                            section.items.map((name, key) => <li key={key}><Link to={name.link}>{name.name}</Link></li>)
                                        }
                                    </ul>
                                </React.Fragment>
                            ))
                        }
                    </div>}
                </Scrollbars>

                <div className="toggle-switch" onClick={this.toggleSidebar}>
                    <Icon name={`chevron-${(isExpanded ? "back" : "next")}-24`}/>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgets/SideNavBar/SideNavBar.js